import React, { Component } from "react";
import TitularTarjeta from './TitularTarjeta.jsx';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper.js';

const BACK_KEY_CODE = 8;
const ENTER_KEY_CODE = 13;
const DELETE_KEY_CODE = 46;

const DataListCustom = (props) => {
    if (props.mostrarLabel == false) {
        return null;
    }

    if (!props.titular || props.titular.length == 0) {
        return null;
    }

    let lista = [props.titular].map((item2, index) => {

        let sexo = "Sin sexo";
        if (item2.Sexo != undefined) {
            switch (item2.Sexo) {
                case "M":
                    sexo = "Masculino";
                    break;
                case "F":
                    sexo = "Femenino";
                    break;
            }
        }

        let estadoCivilCodigo = "Sin estado civil";
        if (item2.EstadoCivil != undefined) {
            if (item2.EstadoCivil.Codigo != undefined) {
                switch (item2.EstadoCivil.Codigo) {
                    case "S":
                        estadoCivilCodigo = item2.Sexo == "F" ? "Soltera" : "Soltero"
                        break;
                    case "C":
                        estadoCivilCodigo = item2.Sexo == "F" ? "Casada" : "Casado"
                        break;
                    case "D":
                        estadoCivilCodigo = item2.Sexo == "F" ? "Divorciada" : "Divorciado"
                        break;
                    case "V":
                        estadoCivilCodigo = item2.Sexo == "F" ? "Viuda" : "Viudo"
                        break;
                    case "E":
                        estadoCivilCodigo = item2.Sexo == "F" ? "Separada" : "Separado"
                        break;
                    case "U":
                        estadoCivilCodigo = "Union Convivencial";
                        break;
                }
            }
        }
        else {
            let codigoAtlasEstadoCivil = props.data.atlasEstadoCivil.find(x => x.ID = item2.EstadoCivilId).CODIGO;
            switch (codigoAtlasEstadoCivil) {
                case "S":
                    estadoCivilCodigo = item2.Sexo == "F" ? "Soltera" : "Soltero"
                    break;
                case "C":
                    estadoCivilCodigo = item2.Sexo == "F" ? "Casada" : "Casado"
                    break;
                case "D":
                    estadoCivilCodigo = item2.Sexo == "F" ? "Divorciada" : "Divorciado"
                    break;
                case "V":
                    estadoCivilCodigo = item2.Sexo == "F" ? "Viuda" : "Viudo"
                    break;
                case "E":
                    estadoCivilCodigo = item2.Sexo == "F" ? "Separada" : "Separado"
                    break;
                case "U":
                    estadoCivilCodigo = "Union Convivencial";
                    break;
            }
        }

        let fechaNacimiento = "Sin fecha de nacimiento";
        if (item2.FechaNacimiento != undefined) {
            let fechaNac = item2.FechaNacimiento.slice(0, -9).split('-');
            fechaNacimiento = fechaNac[2] + "/" + fechaNac[1] + "/" + fechaNac[0];
        }

        let nacionalidadCodigo = "Sin nacionalidad";
        if (item2.Nacionalidad != undefined) {
            if (item2.Nacionalidad.Codigo != undefined) {
                nacionalidadCodigo = props.data.atlasNacional.find(x => x.CODIGO == item2.Nacionalidad.Codigo).DESCRIPCION;
            }
        } else {
            nacionalidadCodigo = props.data.atlasNacional.find(x => x.ID == item2.NacionalidadId).DESCRIPCION;
        }

        let formateado = `${estadoCivilCodigo} - ${sexo}`;
        let formateado2 = `${fechaNacimiento} - ${nacionalidadCodigo}`;

        let tipoDocumentoCodigo = item2.TipoDocumento != undefined ? item2.TipoDocumento.Codigo : item2.TipoDocumentoCodigo

        let nroDocumento = GlobalHelper.ConvertirNumeroDocumento(item2.NumeroDocumento, tipoDocumentoCodigo);
        let nroCuit = GlobalHelper.ConvertirNumeroDocumento(item2.Cuit, "CUIT");

        return <div className="row data-list-tarjetas" key={"item-tar-" + index} onMouseDown={() => { props.onSelectAlgo(item2) }}>
            <div className="col-xs-12">
                <label>
                    {item2.Nombre + " " + item2.Apellido + " "}
                    <div>
                        <label className="gray">
                            {formateado}
                        </label>
                    </div>
                    <div>
                        <label className="gray">
                            {formateado2}
                        </label>
                    </div>
                    <label className="gray">
                        {tipoDocumentoCodigo + " " + nroDocumento + " - CUIT " + nroCuit}
                    </label>
                </label>
            </div>
        </div>
    });

    return (lista == undefined || lista.length == 0) ? null : <div>{lista}</div>;
}

class SelectCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchUser: "",
            busquedaCuit: false,
            mostrarLabel: false,
            tipoDocumentoId: 0
        }

        const dni = props.data.tiposDeDocumentos.find(t => t.VALOR.toUpperCase() == "DNI");

        this.state.tipoDocumentoId = ((dni) ? dni.ID : 0);

        this.handleChange = this.handleChange.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
    }

    tipoDocumentoOnChange(event) {
        this.setState({ tipoDocumentoId: event.target.value });
    }

    componentWillReceiveProps(nextProps) {
        this.state.busquedaCuit = false;
    }

    render() {
        let titCard = this.props.data.titularCard;
        let titularCardsNodes = undefined;
        let mensajeTitularNoEncontrado = undefined;

        if (this.props.data != undefined && this.props.data != "") {

            if (titCard != undefined) {

                if (this.props.data.titularCard.length != undefined) {

                    if (this.props.data.titularCard.length != 0) {

                        mensajeTitularNoEncontrado = undefined;

                        titularCardsNodes = this.props.data.titularCard.map(function (row) {
                            return (
                                <TitularTarjeta row={row} key={"TitularCard_" + row.Id} />
                            );
                        })
                    }
                    else {
                        mensajeTitularNoEncontrado = <label className="error">No se encontró el cliente</label>
                    }
                }
                else {
                    titularCardsNodes = <TitularTarjeta row={this.props.data.titularCard} key={"TitularCard_" + this.props.data.titularCard.Id} />
                    mensajeTitularNoEncontrado = undefined;
                }
            }
            else {
                if (this.props.data.duplicidadTitular) {
                    mensajeTitularNoEncontrado = <label className="error">Cliente ya agregado</label>
                }
            }
        };

        return (
            <div>
                <div id="cardsContainer">
                    {this.state.busquedaCuit == true &&
                        <div className="loading"> Loading &#8230;</div>}
                    <div className="col-xs-4">
                        <div className="input-icon-container">
                            <span className="ti-search input-icon-span"></span>
                            <input list="listUserName"
                                className="form-control input-with-icon"
                                placeholder="Buscar por número"
                                value={this.state.searchUser}
                                onChange={this.handleChange}
                                onKeyUp={this.onKeyUp}
                                onFocus={() => { this.setState({ mostrarLabel: true }); }}
                                onBlur={() => { this.setState({ mostrarLabel: false }) }}
                            />
                        </div>

                        <DataListCustom titular={this.props.data.titularCard}
                            data={this.props.data}
                            mostrarLabel={this.state.mostrarLabel}
                            onSelectAlgo={(valor) => {
                                valor = valor.Nombre + " " + valor.Apellido
                                this.handleChange({ target: { value: valor } })
                            }} />
                        <div>
                            {this.props.data.ERROR_CARD["seleccionoTitular"] == false ? <label className="error">Debe seleccionar al menos un titular.</label> : null}
                        </div>
                    </div>
                    <div className="col-xs-2">
                        <select className="form-control" onChange={this.tipoDocumentoOnChange.bind(this)}>
                            {this.props.data.tiposDeDocumentos.map((tp, index) => {
                                return (
                                    <option value={tp.ID} key={index}>{tp.VALOR}</option>
                                );
                            })}
                        </select>
                    </div>
                </div >
                <div className="col-xs-12">
                    {mensajeTitularNoEncontrado}
                </div>
            </div>
        );
    }

    handleChange(event) {
        let value = event.target.value;
        this.setState({ searchUser: value, mostrarLabel: false });
        let reNum = new RegExp("^[0-9]+$");
        if (!reNum.test(value)) {
            if (value != "") {
                this.props.getHeadline(value);
            }
        }
    }

    onKeyUp(event) {
        if (event.keyCode == 13) {
            let term = this.state.searchUser;
            if (term.length >= 7) {
                let reNumero = new RegExp("^[0-9]{6,11}$");
                if (reNumero.test(term)) {
                    this.setState({ busquedaCuit: true, mostrarLabel: true });
                    this.props.getHeadline(term, this.state.tipoDocumentoId);
                }
            }
        }
    }
}

export default SelectCard